import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPen, faStar } from '@fortawesome/free-solid-svg-icons'

library.add(faPen, faStar)

Vue.component('fa-icon', FontAwesomeIcon)
